import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Paper, TextField, Button, Grid } from '@mui/material';

const CursoNoivos = () => {
  const [dados, setDados] = useState([]);
  const [form, setForm] = useState({ local: '', data1: '', carga_horaria1: '', data2: '', carga_horaria2: '', valor: '' });
  const [editId, setEditId] = useState(null);

  const fetchData = async () => {
    const res = await axios.get('/api/curso_noivos');
    setDados(res.data);
  };

  useEffect(() => { fetchData(); }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (editId) {
      await axios.put(`/api/curso_noivos/${editId}`, form);
    } else {
      await axios.post('/api/curso_noivos', form);
    }
    setForm({ local: '', data1: '', carga_horaria1: '', data2: '', carga_horaria2: '', valor: '' });
    setEditId(null);
    fetchData();
  };

  const handleEdit = item => {
    setForm(item);
    setEditId(item.id);
  };

  const handleDelete = async id => {
    await axios.delete(`/api/curso_noivos/${id}`);
    fetchData();
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Curso de Noivos</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="Local" name="local" value={form.local} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Data 1" name="data1" value={form.data1} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Carga Horária 1" name="carga_horaria1" value={form.carga_horaria1} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Data 2" name="data2" value={form.data2} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Carga Horária 2" name="carga_horaria2" value={form.carga_horaria2} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={6}><TextField label="Valor do Curso" name="valor" value={form.valor} onChange={handleChange} fullWidth /></Grid>
            <Grid item xs={12}><Button type="submit" variant="contained">{editId ? 'Salvar' : 'Adicionar'}</Button></Grid>
          </Grid>
        </form>
      </Paper>
      {dados.map(item => (
        <Paper key={item.id} sx={{ p: 2, mb: 1 }}>
          <Typography><b>Local:</b> {item.local}</Typography>
          <Typography><b>Data 1:</b> {item.data1} ({item.carga_horaria1}h)</Typography>
          <Typography><b>Data 2:</b> {item.data2} ({item.carga_horaria2}h)</Typography>
          <Typography><b>Valor:</b> R$ {item.valor}</Typography>
          <Button onClick={() => handleEdit(item)} sx={{ mr: 1 }}>Editar</Button>
          <Button color="error" onClick={() => handleDelete(item.id)}>Excluir</Button>
        </Paper>
      ))}
    </Container>
  );
};

export default CursoNoivos;
